module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAABkAQMAAADOquA5AAAAA1BMVEWqqqoRfvv5AAAADklEQVR4AWOgARgFowAAAlgAAVzhuFIAAAAASUVORK5CYII="